import React from 'react';

const Footer = () => {
	return (
		<div className="alert alert-dismissible alert-light text-center">
		  <p><span className="badge badge-light">Project Mars</span> A test project for Billie, by Ali Murtaza</p>
		</div>
	);
} 

export default Footer;
